<div class="row g-0 m-0 d-flex align-items-center">
  <div class="col-md-1 pe-4 d-flex justify-content-end">
    <div class="button-back m-0" (click)="goBack()">
      <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
    </div>
  </div>
  <div class="col-md-8 pt-5 pb-3">
    <h2 class="col pb-2 title">
      {{ "EVENT_CODES" | translate }}
    </h2>
    <h6 class="col subtitle">
      {{ "EVENT_CODES_SUBTITLE" | translate }}
      @if (meterModel.model || meterModel.firmwareVersion) {
        <span>
          {{ meterModel.model }}@if (meterModel.firmwareVersion) {({{ meterModel.firmwareVersion }})}.
        </span>
      }
    </h6>
  </div>
  <div class="col-md-3 ps-5 pt-5 pb-5 pe-5 d-flex flex-row align-items-center justify-content-end">
    <div class="button-wrapper ps-2" (click)="download()">
      <div class="button">
        <svg-icon alt="Download" src="../../../../../../assets/core/table/download-button.svg"
          title="{{ 'DOWNLOAD' | translate }}"></svg-icon>
      </div>
    </div>
    <div class="button-wrapper ps-2" (click)="navigate('/upload/event-codes')">
      <div class="button">
        <svg-icon alt="upload" src="../../../../../../assets/core/table/upload.svg"
          title="{{ 'UPLOAD' | translate }}"></svg-icon>
      </div>
    </div>
    @if (authService.isAuthorized([PermissionEnum.Settings_crud_metermodel_modify])) {
      <button class="crud-add-button pt-2 pb-2 ms-4 ps-4 pe-4 rounded ms-2" [disabled]="!hasPendingChanges"
        (click)="save()">
        {{ "SAVE" | translate }}
      </button>
    }
  </div>
</div>

<div class="p-5 pt-0 d-flex flex-column gap-3">
  <div class="row g-0 m-0">
    <ul class="tabs-nav">
      @for (register of eventCodeRegisters; track register) {
      <li (click)="activeRegister = register" [class.active]="activeRegister === register">
        <span>{{ labels[getRegisterNumber(register) - 1] || ("EVENTLOG_TYPE_" + getRegisterNumber(register) | translate) }}</span>
        <span class="event-log-number">{{ "EVENTLOG_" + getRegisterNumber(register) | translate }}</span>
      </li>
      }
    </ul>
  </div>

  <div class="subpage-container mb-5">
    <div class="container g-0 m-0 p-0">
      @for (register of eventCodeRegisters; track register) {
      @if (activeRegister === register) {
      <div class="pt-3">
        @if (authService.isAuthorized([PermissionEnum.Settings_crud_metermodel_modify])) {
        <div class="col-md-4 pb-3 d-flex flex-column form-input">
          <label class="item-name pb-2" for="eventLogLabel">{{ "NAME" | translate }}</label>
          <input id="eventLogLabel" type="text" maxlength="100"
            [(ngModel)]="labels[getRegisterNumber(register) - 1]"
            [placeholder]="'EVENTLOG_TYPE_' + getRegisterNumber(register) | translate" />
        </div>
        }
        <div class="overflow-vertical">
          <table class="configuration-table event-code-table">
            <thead>
              <tr>
                <th>{{ "VALUE" | translate }}</th>
                <th>{{ "EVENT" | translate }}</th>
                <th>{{ "DESCRIPTION" | translate }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (mapping of getMappings(register); track mapping) {
              <tr>
                <td>{{ mapping.value }}</td>
                <td>{{ mapping.eventCodeName }}</td>
                <td>{{ mapping.eventCodeDescription }}</td>
                <td>
                  @if (authService.isAuthorized([PermissionEnum.Settings_crud_metermodel_modify])) {
                  <img src="assets/core/table/delete.svg" (click)="deleteMapping(mapping)" />
                  }
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>

      </div>
      }
      }
    </div>
  </div>
</div>
